import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('text-field')
export class TextField extends LitElement {
  @property({ type: String }) name = '';
  @property({ type: String }) label = '';
  @property({ type: String }) value = '';
  @property({ type: String }) placeholder = '';
  @property({ type: Boolean }) required = false;
  @property({ type: String }) error = '';
  @property({ type: Boolean }) touched = false;

  static styles = css`
    :host {
      display: block;
    }
    .field-group {
      margin-bottom: 16px;
    }
    label {
      display: block;
      margin-bottom: 8px;
      font-weight: 500;
      color: #1e293b;
      font-size: 14px;
    }
    .required {
      color: #ef4444;
    }
    input {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #cbd5e1;
      border-radius: 6px;
      font-size: 14px;
      transition: all 0.2s;
      box-sizing: border-box;
    }
    input:focus {
      outline: none;
      border-color: #4f46e5;
      box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
    }
    input.error {
      border-color: #ef4444;
    }
    .error-message {
      color: #ef4444;
      font-size: 12px;
      margin-top: 4px;
    }
  `;

  private _handleInput(e: Event) {
    const input = e.target as HTMLInputElement;
    this.value = input.value;
    this.dispatchEvent(
      new CustomEvent('field-change', {
        detail: { name: this.name, value: this.value },
        bubbles: true,
        composed: true,
      })
    );
  }

  private _handleBlur() {
    this.dispatchEvent(
      new CustomEvent('field-blur', {
        detail: { name: this.name },
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    return html`
      <div class="field-group">
        <label for=${this.name}>
          ${this.label}
          ${this.required ? html`<span class="required">*</span>` : ''}
        </label>
        <input
          type="text"
          id=${this.name}
          .value=${this.value}
          placeholder=${this.placeholder}
          class=${this.error && this.touched ? 'error' : ''}
          @input=${this._handleInput}
          @blur=${this._handleBlur} />
        ${this.error && this.touched
          ? html` <div class="error-message">${this.error}</div> `
          : ''}
      </div>
    `;
  }
}
